import { SvgIcon, SvgIconProps} from '@mui/material';
import './ccf-sort-by-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfSortByIconProps extends SvgIconProps {}

/**
 * component used to display sort by icon
 * @param props - CcfSortByIcon
 * @example - <CcfSortByIcon />
 * @returns SVG of sort by icon
 */
export function CcfSortByIcon(props: CcfSortByIconProps) {
  return (
    <SvgIcon
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      {...props}
    >
      <path
        d="M1 14.3333H11.8333M1 10.9999H8.5M1 7.66659H8.5M12.6667 10.9999V0.999919M12.6667 0.999919L9.33333 4.33325M12.6667 0.999919L16 4.33325"
        stroke="#3F5C69"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default CcfSortByIcon;
